import "../components/cacheForm.js";

$(document).ready(function() {
  const toggleLoading = function() {
    $('body').toggleClass('is-loading');
  }

  // HS - Mapping
  const languageMap = {
    DE: 'German',
    EN: 'English',
    FR: 'French',
    IT: 'Italian',
    SP: 'Spanish',
    DU: 'Dutch',
    GR: 'Greek',
    RU: 'Russian',
    PR: 'Portuguese',
    TR: 'Turkish'
  }

  const mapLanguage = function(language) {
    var defaultLang = language.split('/')[0].trim();
    return languageMap[defaultLang.toUpperCase()] ? languageMap[defaultLang.toUpperCase()] : null;
  }

  // if job position is provided via query param, its preselected here
  const initializePreselectedValues = function($form) {
    if (document.preselected.language) {
      const hsLanguage = mapLanguage(document.preselected.language);

      if (hsLanguage && hsLanguage !== document.preselected.language) {
        $('input[name="language"]').val(hsLanguage).change();
      }
    }
  }

  const renderProgress = function(index) {
    for (let i = 0; i <= index; i++) {
      $(`.step-${i}`).addClass('active');
    }
    $('[id^=hs-form-iframe]:not(:last)').hide()
  }

  const renderPrevButton = function($form, prevIndex) {
    const elActions = $form.find('.hs-submit .actions');
    const nextButton = $form.find('.hs-submit .actions .hs-button.primary');
    const markup = '<a href="#" class="btn btn-sm btn-secondary mt-16 mt-md-0 " style="background-color:#f5f6f7; color:#4f5fee!important; min-width: 150px; height: 40px; padding: 11px 15px; font-size: 13px; letter-spacing: 1px; font-weight: 600!important; text-decoration: none; text-align: center; font-family: Montserrat,sans-serif;" data-previous="' + prevIndex + '">BACK</a>';
    elActions.prepend(markup)
    elActions.addClass('flex-column flex-md-row-reverse justify-content-md-between')
    elActions[0].style.justifyContent = 'space-between'
    elActions[0].style.display = 'flex'
    nextButton[0].style.minWidth = '150px'
  }

  // injects email in hidden fields on subsequent forms
  const injectEmail = function() {
    if (document.formData && document.formData.email && document.formData.email.length > 0) {
      // wait a bit to make sure to overwrite all other auto fill settings
      setTimeout(function() {
        $('input[name="email"]').val(document.formData.email).change();
      }, 500);

    }
  }

  const cacheForm = function($form, index) {
    const conf = {};
    if (index === 0) {
      conf.elements = 'input[type="email"], input[type="text"], input[type="tel"], input[type="radio"], input[type="checkbox"], select, textarea';
    }

    $form.FormCache(conf);
  }

  const cleanUp = function() {
    if(typeof(Storage)!=="undefined"){
      localStorage.clear();
    }
  }

  const createHSForm = function(index) {
    // create form
    hbspt.forms.create({
      portalId: document.portalId,
      formId: document.formIds[index],
      target: document.targetId,
      region: "eu1",

      onFormReady: function($form) {
        if (!document.formData) document.formData = {};
        // Hide default submit button
        $("#hs-form-iframe-0").find(".hs_submit").hide();
        
        // limit amount of chars in message field
        $('input[name="website"]').attr('maxlength','255').change();
        $('input[name="company"]').attr('maxlength','255').change();
        $('input[name="lastname"]').attr('maxlength','255').change();
        $('input[name="jobtitle"]').attr('maxlength','255').change();
        $('input[name="firstname"]').attr('maxlength','255').change();
        $('textarea[name="message"]').attr('maxlength','255').change();

        renderProgress(index);

        // populate email field (hidden in all but first form)
        injectEmail($form);

        // inject previous button
        if (index > 0) {
          const prevIndex = index - 1;
          renderPrevButton($form, prevIndex);

          // register event handler for prev button
          $form.on('click', '[data-previous]', function(evt) {
            toggleLoading();
            $(`#hs-form-iframe-${index}`).hide();
            createHSForm($(evt.currentTarget).data('previous'));
          });
        } else {
          initializePreselectedValues($form);
        }

        cacheForm($form, index);
        toggleLoading();
      },
      onFormSubmit: function($form) {
        toggleLoading();
        if (typeof gtag !== 'undefined') {
          gtag('event', 'conversion', {'send_to': 'AW-874316721/jLmiCLuOqGoQsYf0oAM'});
          gtag('event', 'form.submit', {});
        }

        // store email address to populate fields in subsequent forms
        // this makes sure tracking works in any case
        if (index === 0) {
          const email = $form.find('input[name="email"]').val();
          document.formData.email = email;
        }
      },
      onFormSubmitted: function($form) {
        if (index < document.formIds.length - 1) {
          index ++;
          createHSForm(index);
        } else {
          // clean up
          cleanUp();
          $('body').removeClass('is-loading');
          $(`.step-${document.formIds.length}`).addClass('active');
          $('#paginator-container').css('margin-top', '65vh');
        }
      }
    });
  }

  // FLOW
  var index = 0;
  toggleLoading();
  $(document).ready(function(){
    createHSForm(index);
  });
});
